import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a781fd50"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "animate modal"
}
const _hoisted_2 = { class: "modal-inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Respuesta enviada", -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", { style: {"font-size":"14px"} }, "¡Gracias por contribuir!"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Con aportes como el tuyo, mejoramos todos. ¡Gracias!")
], -1))
const _hoisted_6 = { class: "animate form" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Redactar Respuesta", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Asegúrate de usar un formato legible.", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import ForumService from '@/services/ForumService'
import { useAuth } from '@/store/useAuth'
import useWindowWidth from '@/composables/useWindowWidth'
import { useToast } from '@/store/useToast'
import { Toast } from '@/interfaces/ToastInterface';
import { useRouter } from 'vue-router'
import main from '@/data/main.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'MyAnswerView',
  setup(__props) {

const toast = useToast()
const service = new ForumService()
const store = useAuth()
const name = ref('')
const answer = ref('')
const showFeedback = ref(false)
const {windowWidth} = useWindowWidth()
const answerBox = ref()
const route = useRoute()
const question_id = route.params.question_id
const router = useRouter()

const handleAnswer = () => {
    answer.value = answerBox.value.getHTML()
}

const storeAnswer = async () => {
    if (!store.token) { return; }
    const response = await service.WriteAnswer(store.token, question_id, answer.value)
    console.log("response", response)
    if (response != true) {
        toast.showToast("Upps... Algo salió mal.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return
    }
    showFeedback.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_quill_editor = _resolveComponent("quill-editor")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (showFeedback.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              (_unref(windowWidth) >= 1000)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _unref(main).ANSWERVIEW_IMG,
                    style: {"width":"100%"}
                  }, null, 8, _hoisted_4))
                : _createCommentVNode("", true),
              _hoisted_5,
              _createElementVNode("button", {
                class: "new-question",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
              }, "Aceptar")
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _hoisted_8,
        _hoisted_9,
        _createVNode(_component_quill_editor, {
          ref_key: "answerBox",
          ref: answerBox,
          theme: "snow",
          toolbar: "full",
          "onUpdate:content": handleAnswer
        }, null, 512),
        _hoisted_10,
        _createElementVNode("button", {
          class: "new-question",
          onClick: storeAnswer
        }, [
          _createTextVNode("Enviar Respuesta "),
          _createVNode(_component_v_icon, {
            name: "io-send",
            style: {"margin-left":"10px"}
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})